import { Box, Divider, Drawer, Stack, useTheme } from "@mui/material";
import MenuSide from "./menuside.component";
import { useDrawerStyles } from "../../styles/commonStyles";
import LogoutButton from "../buttons/logoutButton.component";
import { useLogout } from "../../utils/logoutUtils";

const iconStyle = { width: "14px", height: "14px" };
const buttonStyle = (theme, isDrawerOpen) => ({
  color: theme?.palette.primary.contrastText,
  textTransform: "none",
  fontWeight: 500,
  fontSize: "12px",
  justifyContent: "center",
  minWidth: 0,
  padding: isDrawerOpen ? "6px 8px" : "6px",
});
const MuiDrawer = ({ logo, logoSmall, isDrawerOpen, userType, feVersion }) => {
  const theme = useTheme();
  const classes = useDrawerStyles({ isDrawerOpen });
  const desktopWidth = isDrawerOpen ? "160px" : "32px";
  const { handleLogout } = useLogout(userType);

  return (
    <Box>
      <Drawer variant="permanent" className={classes.drawer}>
        <Box className={classes.logoContainer}>
          <img
            src={isDrawerOpen ? logo : logoSmall}
            alt="Smaart"
            className={classes.logo}
          />
        </Box>
        <MenuSide isDrawerOpen={isDrawerOpen} desktopWidth={desktopWidth} />
        <Box className={classes.bottomContainer}>
          <Stack
            direction="row"
            spacing={isDrawerOpen ? 2 : 0}
            alignItems="center"
            justifyContent="center"
          >
            <LogoutButton
              handleLogout={handleLogout}
              isDrawerOpen={isDrawerOpen}
              iconStyle={iconStyle}
              buttonStyle={buttonStyle(theme, isDrawerOpen)}
            />
          </Stack>
          {isDrawerOpen && (
            <Box sx={{ width: "100%", marginY: 2 }}>
              <Divider
                sx={{ backgroundColor: theme.palette.primary.contrastText }}
              />
            </Box>
          )}
          <Box className={classes.version}>
            {isDrawerOpen ? `Versione ${feVersion}` : ""}
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default MuiDrawer;
